<form class="row" [formGroup]="form">
  @if (isReadOnly) {
  <div class="col-lg-6">
    <div class="mb-3 row">
      <div class="col-lg-4">
        <label for="hastaNo" class="form-label">{{
          "case.patient-informations.patient-no" | translate
        }}</label>

        <app-readonly-input
          [value]="form.controls['patientNo']?.value"
        ></app-readonly-input>
      </div>

      <div class="col-lg-8 row">
        <div [class.col-md-8]="!hiddenFields['unidentified']">
          <label for="patientIdNumber" class="form-label">{{
            "case.patient-informations.id-number" | translate
          }}</label>

          <app-readonly-input
            [value]="readonlyInformations?.idNumber"
          ></app-readonly-input>
        </div>

        <div class="col-md-4" *ngIf="!hiddenFields['unidentified']">
          <label for="kimliksiz" class="form-label">{{
            "case.patient-informations.is-identified" | translate
          }}</label>
          <div class="form-check ms-3">
            @if (!form.controls['unidentified']?.value) {
            <i class="fa fa-xmark" style="color: red"></i>
            } @else {
            <i class="fa fa-check" style="color: green"></i>
            }
          </div>
        </div>
      </div>
    </div>

    <div class="mb-3 row">
      <div class="col-lg-6">
        <label for="patientName" class="form-label required-star">{{
          "case.patient-informations.name" | translate
        }}</label>

        <app-readonly-input
          [value]="readonlyInformations?.firstName"
        ></app-readonly-input>
      </div>

      <div class="col-lg-6">
        <label for="patientSurname" class="form-label required-star">{{
          "case.patient-informations.surname" | translate
        }}</label>
        <app-readonly-input
          [value]="readonlyInformations?.lastName"
        ></app-readonly-input>
      </div>
    </div>

    <div class="mb-3 row">
      <div class="col-md-6">
        <label for="birthDate" class="form-label">{{
          "case.patient-informations.birth-date" | translate
        }}</label>

        <app-readonly-input
          [type]="'date'"
          [value]="form.controls['birthDate']?.value"
        ></app-readonly-input>
      </div>

      <div class="col-md-6">
        <label for="yas" class="form-label">{{
          "case.patient-informations.age" | translate
        }}</label>
        <app-readonly-input
          [value]="form.controls['age']?.value"
        ></app-readonly-input>
      </div>
    </div>

    <div class="mb-3 row">
      <div class="col-lg-4">
        <label for="pasaportNo" class="form-label">{{
          "case.patient-informations.passport-no" | translate
        }}</label>

        <app-readonly-input
          [value]="readonlyInformations?.passportNo"
        ></app-readonly-input>
      </div>
      <div class="col-lg-3">
        <label for="yabanciUyruklu" class="form-label">{{
          "case.patient-informations.is-foreign" | translate
        }}</label>

        <div class="form-check ms-3">
          @if (!form.controls['isForeignNational']?.value) {
          <i class="fa fa-xmark" style="color: red"></i>
          } @else {
          <i class="fa fa-check" style="color: green"></i>
          }
        </div>
      </div>
      <div class="col-lg-6" *ngIf="form.controls['isForeignNational']?.value">
        <label for="country" class="form-check-label">{{
          "case.patient-informations.country" | translate
        }}</label>

        <app-readonly-input
          [value]="readonlyInformations?.country?.label"
        ></app-readonly-input>
      </div>
    </div>
    <div class="mb-3"></div>

    <div class="mb-3 row">
      <div class="col-md-6">
        <label for="gender" class="form-label">{{
          "case.patient-informations.gender" | translate
        }}</label>

        <app-readonly-input
          [value]="readonlyInformations?.gender | gender"
        ></app-readonly-input>
      </div>
      <div class="col-md-6">
        <label for="bloodGroup" class="form-label">{{
          "case.patient-informations.blood-group" | translate
        }}</label>

        <app-readonly-input
          [value]="readonlyInformations?.bloodGroup?.label"
        ></app-readonly-input>
      </div>
    </div>

    <div class="mb-3">
      <label for="notlar" class="form-label">{{
        "case.patient-informations.description" | translate
      }}</label>

      <app-readonly-input
        [type]="'textarea'"
        [value]="readonlyInformations?.description"
      ></app-readonly-input>
    </div>
  </div>
  } @else {
  <div class="col-lg-6">
    <div class="mb-3 row">
      <div class="col-lg-4">
        <label for="hastaNo" class="form-label">{{
          "case.patient-informations.patient-no" | translate
        }}</label>
        <app-patient-card
          (openDetailOn)="onOpenDetail($event)"
          (selectOn)="onPatientSelect($event)"
          [isApproved]="isCaseApproved ?? false"
          #patientCard
        ></app-patient-card>
      </div>
      <div class="col-lg-8 row">
        <div [class.col-md-8]="!hiddenFields['unidentified']">
          <label for="patientIdNumber" class="form-label">{{
            "case.patient-informations.id-number" | translate
          }}</label>
          @if (form.controls['patientNo']?.value || isCaseApproved) {
          <app-readonly-input
            [value]="form.controls['idNumber']?.value"
          ></app-readonly-input>
          } @else {
          <div class="input-group search-container">
            <div class="search-container">
              <input
                type="text"
                id="patientIdNumber"
                maxlength="11"
                pattern="\d*"
                (input)="onIdNumberInput($event)"
                class="form-control"
                formControlName="idNumber"
                [placeholder]="
                  'case.patient-informations.id-number' | translate
                "
              />
              <div class="icon-container">
                @if(form.controls['idNumberVerified']?.value){
                <i
                  class="fa-solid icon-button fa-circle-check"
                  style="color: #63e6be"
                ></i>
                }@else if(form.controls['idNumber']?.value &&
                !form.controls['idNumberVerified']?.value) {
                <i
                  class="fa-solid icon-button fa-circle-xmark"
                  style="color: #ce1212"
                ></i>
                }
                <button class="icon-button" (click)="searchIdNumber()">
                  <i class="fa-solid fa-magnifying-glass"></i>
                </button>
              </div>
            </div>
          </div>
          }

          <div
            class="text-danger"
            *ngIf="form.get('idNumber')?.hasError('invalidTCKN')"
          >
            {{ "case.patient-informations.invalid-id-number" | translate }}
          </div>
        </div>

        <div class="col-md-4" *ngIf="!hiddenFields['unidentified']">
          <label for="kimliksiz" class="form-label">{{
            "case.patient-informations.is-identified" | translate
          }}</label>
          <div class="form-check ms-3">
            <input
              type="checkbox"
              id="kimliksiz"
              class="form-check-input"
              [placeholder]="
                'case.patient-informations.is-identified' | translate
              "
              formControlName="unidentified"
            />
          </div>
        </div>
      </div>
    </div>

    <div class="mb-3 row">
      <div class="col-lg-6">
        <label for="patientName" class="form-label required-star">{{
          "case.patient-informations.name" | translate
        }}</label>

        @if (form.controls['patientNo']?.value || isCaseApproved) {
        <app-readonly-input
          [value]="form.controls['firstName']?.value"
        ></app-readonly-input>
        } @else {
        <input
          type="text"
          id="patientName"
          class="form-control"
          formControlName="firstName"
          [placeholder]="'case.patient-informations.name' | translate"
        />
        }
      </div>
      <div class="col-lg-6">
        <label for="patientSurname" class="form-label required-star">{{
          "case.patient-informations.surname" | translate
        }}</label>

        @if (form.controls['patientNo']?.value || isCaseApproved) {
        <app-readonly-input
          [value]="form.controls['lastName']?.value"
        ></app-readonly-input>
        } @else {
        <input
          type="text"
          id="patientSurname"
          class="form-control"
          formControlName="lastName"
          [placeholder]="'case.patient-informations.surname' | translate"
        />
        }
      </div>
    </div>

    <div class="mb-3 row">
      <div class="col-md-6">
        <label for="birthDate" class="form-label">{{
          "case.patient-informations.birth-date" | translate
        }}</label>

        @if (form.controls['patientNo']?.value) {
        <app-readonly-input
          [value]="form.controls['birthDate']?.value"
          [type]="'date'"
        ></app-readonly-input>
        } @else {
        <p-calendar
          formControlName="birthDate"
          id="birthDate"
          [placeholder]="'case.patient-informations.birth-date' | translate"
          [showTime]="false"
          [showButtonBar]="true"
          [maxDate]="maxDate"
          appendTo="body"
        />
        }
      </div>

      <div class="col-md-6">
        <label for="yas" class="form-label">{{
          "case.patient-informations.age" | translate
        }}</label>

        @if (form.controls['patientNo']?.value) {
        <app-readonly-input
          [value]="form.controls['age']?.value"
        ></app-readonly-input>
        } @else {
        <input
          type="number"
          id="yas"
          class="form-control"
          formControlName="age"
          [placeholder]="'case.patient-informations.age' | translate"
          appPreventNegativeInput
          [min]="0"
        />
        }
      </div>
    </div>

    <div class="mb-3 row">
      <div class="col-lg-4">
        <label for="pasaportNo" class="form-label">{{
          "case.patient-informations.passport-no" | translate
        }}</label>

        @if (form.controls['patientNo']?.value) {
        <app-readonly-input
          [value]="form.controls['passportNo']?.value"
        ></app-readonly-input>
        } @else {
        <input
          type="text"
          id="pasaportNo"
          class="form-control"
          formControlName="passportNo"
          [placeholder]="'case.patient-informations.passport-no' | translate"
        />
        }
      </div>

      <div class="col-lg-3">
        <label for="yabanciUyruklu" class="form-label">{{
          "case.patient-informations.is-foreign" | translate
        }}</label>

        @if (form.controls['patientNo']?.value) {

        <div class="form-check ms-3">
          @if (!form.controls['isForeignNational']?.value) {
          <i class="fa fa-xmark" style="color: red"></i>
          } @else {
          <i class="fa fa-check" style="color: green"></i>
          }
        </div>
        } @else {
        <div class="form-check form-switch">
          <input
            type="checkbox"
            id="yabanciUyruklu"
            class="form-check-input"
            [placeholder]="'case.patient-informations.is-foreign' | translate"
            formControlName="isForeignNational"
          />
        </div>
        }
      </div>

      <div class="col-lg-5" *ngIf="form.controls['isForeignNational']?.value">
        <label for="country" class="form-check-label">{{
          "case.patient-informations.country" | translate
        }}</label>
        <p-dropdown
          [style]="{ width: '100%' }"
          [options]="countries"
          formControlName="country"
          [filter]="true"
          [showClear]="true"
          appendTo="body"
          [placeholder]="'case.patient-informations.country' | translate"
        ></p-dropdown>
      </div>
    </div>

    <div class="mb-3 row">
      <div class="col-md-6">
        <label for="gender" class="form-label">{{
          "case.patient-informations.gender" | translate
        }}</label>
        <p-dropdown
          [options]="genders"
          id="gender"
          formControlName="gender"
          [showClear]="true"
          [placeholder]="'case.patient-informations.gender' | translate"
          appendTo="body"
        >
        </p-dropdown>
      </div>
      <div class="col-md-6">
        <label for="bloodGroup" class="form-label">{{
          "case.patient-informations.blood-group" | translate
        }}</label>
        <p-dropdown
          [options]="bloodGroups"
          formControlName="bloodGroup"
          [showClear]="true"
          [placeholder]="'case.patient-informations.blood-group' | translate"
          [filter]="true"
          id="bloodGroup"
          appendTo="body"
        ></p-dropdown>
      </div>
    </div>

    <div class="mb-3">
      <label for="notlar" class="form-label">{{
        "case.patient-informations.description" | translate
      }}</label>
      <textarea
        id="notlar"
        class="form-control"
        rows="3"
        [placeholder]="'case.patient-informations.description' | translate"
        formControlName="description"
      ></textarea>
    </div>
  </div>
  }
  <div class="col-lg-6 divider-col">
    <div class="col-xl-12 mb-3">
      <app-phone-list
        #phoneList
        [phones]="phones"
        [types]="phoneTypes"
        [showSearchIcon]="form.controls['patientNo'].value"
        [showDescriptionInput]="true"
        [isReadOnly]="isReadOnly"
        (phoneItemsChange)="updatePhoneItems($event)"
        (onSearchClicked)="onPhoneSearchClicked()"
        [patientPhones]="patientPhonesCount.length"
      ></app-phone-list>
    </div>

    <div class="col-xl-12 mb-3">
      <app-email-list
        #emailList
        [emails]="emails"
        [types]="emailTypes"
        [isReadOnly]="isReadOnly || (isCaseApproved ?? false)"
        [showSearchIcon]="form.controls['patientNo'].value"
        (emailItemsChange)="updateEmailItems($event)"
        (searchClicked)="onEmailSearchClicked()"
        [form]="form"
        [patientEmails]="patientEmailsCount.length"
      ></app-email-list>
    </div>
    <div class="col-xl-12">
      <label class="form-check-label form-label" for="">{{
        "shared-components.medical-records" | translate
      }}</label>
      <!-- [icdCodes]="icdCodeList" -->
      <app-medical-records
        [medicalRecords]="medicalRecords"
        [isReadOnly]="isReadOnly"
        (medicalRecordsChange)="updateMedicalRecords($event)"
        #medicalRecord
      ></app-medical-records>
    </div>
  </div>
</form>

<div *ngIf="showDialog">
  <app-patient-create #createPatient></app-patient-create>
</div>

<app-patient-phone-popup
  (saveOn)="savePhone($event)"
  #phonePopup
></app-patient-phone-popup>
<app-patient-email-popup
  (saveOn)="saveEmail($event)"
  #emailPopup
></app-patient-email-popup>